import { render, staticRenderFns } from "./colorChooser.vue?vue&type=template&id=786a4a88&scoped=true"
import script from "./colorChooser.vue?vue&type=script&lang=js"
export * from "./colorChooser.vue?vue&type=script&lang=js"
import style0 from "./colorChooser.vue?vue&type=style&index=0&id=786a4a88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786a4a88",
  null
  
)

export default component.exports